import { Component, createRef } from 'react';
import Matter from 'matter-js';
import io from 'socket.io-client';
import { isSocket } from "./Api.js";
import { v4 } from 'uuid';
import MyRender from './MyRender';
import { Col, Row } from 'react-bootstrap';
import 'pathseg'
import checkPointURL from './assets/map/checkpoint3.png'
import rightURL from './assets/map/question_right.png'
import wrongURL from './assets/map/question_wrong.png'
import buildMap from './buildMap.js';
import gateURL from './assets/map/gate.png'

export class MyComponent extends Component {
	Engine;
	Render;
	Bodies;
	Composite;
	Runner;
	engine;
	myRender;
	constructor() {
		super();
		this.gameCanvas = createRef();
		this.nameInput = createRef();
		this.messageList = createRef();
		this.timer = createRef();
		this.rankingList = createRef();
		this.resetBtn = createRef();
		this.gameLoop = this.gameLoop.bind(this);
	}

	state = {
		onGround: true,
		joined: false,
		socket: io(
			isSocket ? "https://api.xianzhaoduan.com/" : "http://127.0.0.1:8888/",
			isSocket ? { path: '/uts-interactive/socket.io', withCredentials: true, transports: ['websocket'] } : { withCredentials: true, transports: ['websocket'] }),
		player: Matter.Bodies.rectangle(200, 200, 80, 80, { inertia: Infinity }),
		other_player: {},
		willBounce: [false, 0],
		players: 0,
		gate: undefined,
		spawnPoint: { x: 47, y: 467 }
	}

	keyboard = (keyCode) => {
		let key = {};
		key.code = keyCode;
		key.isDown = false;
		key.isUp = true;
		key.press = undefined;
		key.release = undefined;
		key.interval = undefined;
		key.downHandler = event => {
			if (key.code.includes(event.keyCode)) {
				if (key.isUp && key.press) {
					if (this.state.player.sleeping) {
						return
					}
					key.interval = setInterval(() => {
						key.press();
					});
				}
				key.isDown = true;
				key.isUp = false;
			}
			if (event.keyCode > 36 && event.keyCode < 40) {
				event.preventDefault();
			}
		};

		//The `upHandler`
		key.upHandler = event => {
			// console.log(event);
			if (key.code.includes(event.keyCode)) {
				if (key.isDown && key.release) {
					key.release()
					clearInterval(key.interval)
				};
				// console.log("key release");
				key.isDown = false;
				key.isUp = true;
			}
			if (keyCode > 36 && keyCode < 40) {
				event.preventDefault();
			}
		};

		//Attach event listeners
		window.addEventListener(
			"keydown", key.downHandler.bind(key), true
		);
		window.addEventListener(
			"keyup", key.upHandler.bind(key), true
		);
		// this.gameCanvas.current.addEventListener("blur", key.upHandler.bind(key), false)
		return key;
	}

	registerSocketListener = () => {
		this.state.socket.on("connect_error", (err) => {
			// the reason of the error, for example "xhr poll error"
			// console.log(err.message);

			// some additional description, for example the status code of the initial HTTP response
			// console.log(err.description);

			// some additional context, for example the XMLHttpRequest object
			// console.log(err.context);
		});

		this.state.socket.on("allow to join", (data) => {
			if (data.name == undefined) {
				var playerBody = this.Bodies.rectangle(this.state.spawnPoint.x, this.state.spawnPoint.y, 112, 40, {
					inertia: Infinity,
					isSensor: true,
					uuid: data.uuid,
					render: {
						visible: false
					}
				})
				this.setState({ player: playerBody }, () => {
					Matter.World.add(this.engine.world, playerBody)
					this.state.socket.emit("joined", { name: playerBody.name, uuid: playerBody.uuid, position: playerBody.position, velocity: playerBody.velocity })
				})

			} else {
				var playerBody = this.Bodies.rectangle(this.state.spawnPoint.x, this.state.spawnPoint.y, 112, 40, {
					inertia: Infinity,
					render: {
						lineWidth: 1
					}
				})
				playerBody.bodyType = "player"
				playerBody.uuid = data.uuid
				playerBody.name = data.name
				playerBody.friction = 0
				playerBody.frictionAir = 0
				playerBody.collisionFilter = {
					category: 0x0002,
					mask: 0x0001
				}
				this.setState({ player: playerBody }, () => {
					Matter.World.add(this.engine.world, playerBody)
					this.state.socket.emit("player joined", { name: playerBody.name, uuid: playerBody.uuid, position: playerBody.position, velocity: playerBody.velocity })
				})
			}
		})

		this.state.socket.on("update player list", (data) => {

			if (data.gameStarted) {
				Matter.World.remove(this.engine.world, this.state.gate)
			}

			var bodies = this.Composite.allBodies(this.engine.world)
			var bodiesUUID = []
			bodies.forEach(body => {
				if (body.uuid != undefined) {
					bodiesUUID.push(body.uuid)
				}
			});

			// console.log("update bodies", data, bodiesUUID);
			var new_other_player = this.state.other_player
			// console.log(data);
			Object.keys(data['users']).forEach((player) => {
				if (!bodiesUUID.includes(player) && data['users'][player].name != undefined) {
					// console.log("------", data['users'][player]);
					var playerBody = this.Bodies.rectangle(this.state.spawnPoint.x, this.state.spawnPoint.y, 25, 63, {
						inertia: Infinity, isStatic: true,
						render: {
							lineWidth: 0
						},
						position: data['users'][player].position,
						velocity: data['users'][player].velocity,
						collisionFilter: {
							category: 0x0002,
							mask: 0x0001
						}
					})
					playerBody.uuid = player
					playerBody.bodyType = "player"
					playerBody.name = data['users'][player].name
					Matter.World.add(this.engine.world, playerBody)
					new_other_player[playerBody.uuid] = playerBody
				}
			})
			this.setState({ other_player: new_other_player, players: Object.keys(data['users']).length }, () => {
				if (data["joinedPlayerName"] != undefined) {
					this.pushMessage(data["joinedPlayerName"])
				}
			})
		})

		this.state.socket.on("update position", (data) => {
			if (Object.keys(this.state.other_player).length !== 0) {
				Object.keys(data).forEach((uuid) => {
					var player = data[uuid]
					if (uuid != this.state.player.uuid) {
						Matter.Body.setPosition(this.state.other_player[uuid], player.position)
						Matter.Body.setVelocity(this.state.other_player[uuid], player.velocity)
						var new_other_player = this.state.other_player
						new_other_player[uuid].powered = player.powered
						new_other_player[uuid].sleeping = player.sleeping
						this.setState({ other_player: new_other_player })
					}
				})
			}
		})

		this.state.socket.on("player leaved", (uuid) => {
			var leaved = this.state.other_player[uuid]
			var new_other_player = this.state.other_player
			delete new_other_player[uuid]
			this.setState({ other_player: new_other_player, players: this.state.players - 1 }, () => {
				if (leaved != undefined) {
					Matter.World.remove(this.engine.world, leaved)
					this.pushMessage(leaved.name, false)
				}
			})
		});

		this.state.socket.on("game start", () => {
			// alert("gameStart")
			Matter.World.remove(this.engine.world, this.state.gate)
		})
		this.state.socket.on("update ranking", (data) => {
			// alert('')
			this.rankingList.current.innerHTML = ""
			// console.log(data);
			data.forEach((result, index) => {
				var li = document.createElement("div");
				const d = new Date(Date.UTC(0, 0, 0, 0, 0, 0, result.result))
				// Pull out parts of interest
				var parts = [
					d.getUTCMinutes(),
					d.getUTCSeconds(),
					d.getMilliseconds(),
				]
				var nameSpan = document.createElement("span")
				nameSpan.appendChild(document.createTextNode(index + 1 + " " + result.name))
				nameSpan.style.color = "blue"
				li.appendChild(nameSpan)
				li.appendChild(document.createTextNode(`: ${parts[0] + "m " + String(parts[1]).padStart(2, '0') + "s " + String(parts[2]).padStart(3, '0') + "ms"}`));
				li.style.textAlign = "left"
				this.rankingList.current.appendChild(li)
			})
		})
	}

	bindKeys = () => {
		this.left = this.keyboard([37, 65])
		this.up = this.keyboard([38, 87])
		this.right = this.keyboard([39, 68])
		this.down = this.keyboard([83, 40])
		var normal_speed = 2.5
		var powered_speed = 5

		this.left.press = () => {
			const speed = this.state.player ? (this.state.player.powered ? powered_speed : normal_speed) : normal_speed
			Matter.Body.setVelocity(this.state.player, Matter.Vector.create(-speed, this.state.player.velocity.y))
		}

		this.left.release = () => {
			if (!this.right.isDown) {
				Matter.Body.setVelocity(this.state.player, Matter.Vector.create(0, this.state.player.velocity.y))
			}
		}

		this.right.press = () => {
			const speed = this.state.player ? (this.state.player.powered ? powered_speed : normal_speed) : normal_speed
			Matter.Body.setVelocity(this.state.player, Matter.Vector.create(speed, this.state.player.velocity.y))
		}

		this.right.release = () => {
			if (!this.left.isDown) {
				Matter.Body.setVelocity(this.state.player, Matter.Vector.create(0, this.state.player.velocity.y))
			}
		}

		this.up.press = () => {
			const speed = this.state.player ? (this.state.player.powered ? powered_speed : normal_speed) : normal_speed
			Matter.Body.setVelocity(this.state.player, Matter.Vector.create(this.state.player.velocity.x, -speed))
		}

		this.up.release = () => {
			if (!this.down.isDown) {
				Matter.Body.setVelocity(this.state.player, Matter.Vector.create(this.state.player.velocity.x, 0))
			}
		}

		this.down.press = () => {
			const speed = this.state.player ? (this.state.player.powered ? powered_speed : normal_speed) : normal_speed
			Matter.Body.setVelocity(this.state.player, Matter.Vector.create(this.state.player.velocity.x, speed))
		}

		this.down.release = () => {
			if (!this.up.isDown) {
				Matter.Body.setVelocity(this.state.player, Matter.Vector.create(this.state.player.velocity.x, 0))
			}
		}
	}

	bindSpectatorKeys = () => {
		this.left = this.keyboard([37, 65])
		this.up = this.keyboard([38, 87])
		this.right = this.keyboard([39, 68])
		this.down = this.keyboard([83, 40])

		var moveSpeedH = 2
		var moveSpeedV = 2

		this.left.press = () => {
			Matter.Body.setPosition(this.state.player, { x: this.state.player.position.x - moveSpeedH, y: this.state.player.position.y })
		}

		this.left.release = () => {
			if (!this.right.isDown) {
				Matter.Body.setVelocity(this.state.player, Matter.Vector.create(0, this.state.player.velocity.y))
			}
		}

		this.right.press = () => {
			Matter.Body.setPosition(this.state.player, { x: this.state.player.position.x + moveSpeedH, y: this.state.player.position.y })
		}

		this.right.release = () => {
			if (!this.left.isDown) {
				Matter.Body.setVelocity(this.state.player, Matter.Vector.create(0, this.state.player.velocity.y))
			}
		}

		this.up.press = () => {
			Matter.Body.setPosition(this.state.player, { x: this.state.player.position.x, y: this.state.player.position.y - moveSpeedV })
		}

		this.up.release = () => {
			if (!this.left.isDown) {
				Matter.Body.setVelocity(this.state.player, Matter.Vector.create(this.state.player.velocity.y, 0))
			}
		}

		this.down.press = () => {
			Matter.Body.setPosition(this.state.player, { x: this.state.player.position.x, y: this.state.player.position.y + moveSpeedV })
		}

		this.down.release = () => {
			if (!this.left.isDown) {
				Matter.Body.setVelocity(this.state.player, Matter.Vector.create(this.state.player.velocity.y, 0))
			}
		}
	}

	renderCanvas = (name) => {
		this.gameCanvas.current.innerHTML = ""
		this.Engine = Matter.Engine
		this.Render = MyRender
		this.Bodies = Matter.Bodies
		this.Composite = Matter.Composite
		this.Runner = Matter.Runner

		// 3. 创建引擎
		this.engine = this.Engine.create()
		this.engine.world.gravity.y = 0;
		// 4. 创建渲染器，并将引擎连接到画布上
		let render = this.Render.create({
			element: document.getElementById('game-canvas'), // 绑定页面元素
			engine: this.engine, // 绑定引擎
			options: {
				wireframes: false,
				background: "#eeeeee",
				hasBounds: true,
				// background: "#14151f",
				height: 600,
				width: 900
			}
		})
		this.myRender = render
		this.registerMatterEventListener()

		// 6. 将所有物体添加到世界中
		var gate = buildMap.rectangle(653, 424, 27, 168, gateURL)
		this.setState({ gate: gate })
		buildMap.build(this.Composite, this.engine.world)
		this.Composite.add(this.engine.world, [
			gate
		])
		// 7. 执行渲染操作
		this.Render.run(render)
		// 8. 创建运行方法
		var runner = this.Runner.create()
		// 9. 运行渲染器
		this.Runner.run(runner, this.engine)
		this.state.socket.emit("request to join", { name: name, uuid: v4() })
		// Matter.World.remove(this.engine.world, this.state.gate)
	}

	registerMatterEventListener = () => {
		Matter.Events.on(this.engine, 'collisionStart', (event) => {
			var pairs = event.pairs;
			pairs.forEach(pair => {
				if (pair.bodyA === this.state.player && this.state.player.name) {
					if (pair.bodyB.bodyType === "cookie") {
						if (this.state.player.powered != true) {
							this.state.player.powered = true
							var countdown = 3
							var timer = setInterval(() => {
								if (countdown == 0) {
									clearInterval(timer)
									this.state.player.powered = false
								}
								countdown--
							}, 1000)
						}
					}
					if (pair.bodyB.isStart && this.state.startTime === undefined) {
						this.setState({ startTime: Date.now() })
					}
					if (pair.bodyB.isEnd && this.state.startTime !== undefined) {
						this.arrive()
					}
				} else if (pair.bodyB === this.state.player && this.state.player.name) {
					if (pair.bodyA.bodyType === "cookie") {
						if (this.state.player.powered != true) {
							this.state.player.powered = true
							var countdown = 3
							var repeat = () => {
								this.state.player.poweredLeft = countdown
								if (countdown == 0) {
									clearInterval(timer)
									this.state.player.poweredLeft = undefined
									this.state.player.powered = false
								}
								countdown--
								return repeat
							}
							var timer = setInterval(repeat(), 1000)
						}
					}
					if (pair.bodyA.isStart && this.state.startTime === undefined) {
						this.setState({ startTime: Date.now() })
					}
					if (pair.bodyA.isEnd && this.state.startTime !== undefined) {
						this.arrive()
					}
					if (pair.bodyA.bodyType === "question") {
						const q = pair.bodyA.question
						const a = pair.bodyA.answer
						if(!pair.bodyA.answered){
							var answer = prompt(q)
							if(answer != undefined){
								answer = answer.trim()
								if (answer.endsWith('.')){
									answer = answer.substring(0,answer.length-1)
								}
								Matter.Body.setVelocity(this.state.player, {x:0,y:0})
								if(answer === a) {
									pair.bodyA.render.sprite.texture = rightURL
									pair.bodyA.answered = true
	
								}else {
									pair.bodyA.render.sprite.texture = wrongURL
									this.state.player.sleeping = true
									var countdown = 5
									Matter.Body.setVelocity(this.state.player, {x:0,y:0})
									var repeat = () => {
										this.state.player.sleepingLeft = countdown
										if (countdown == 0) {
											clearInterval(timer)
											this.state.player.sleepingLeft = undefined
											this.state.player.sleeping = false
										}
										countdown--
										return repeat
									}
									var timer = setInterval(repeat(), 1000)
								}
							}
							
							Matter.Body.setPosition(this.state.player, {x:this.state.player.position.x-8,y:this.state.player.position.y})
							var temp = [37,38,39,40,65,87,68,83].forEach((keyCode) => {
								window.dispatchEvent(new KeyboardEvent("keyup", { "keyCode": keyCode }))
							})
							Matter.Body.setVelocity(this.state.player, { x: 0, y: 0 })
						}
					}
				}
			})
		})
	}

	arrive = () => {
		var result = Date.now() - this.state.startTime
		clearInterval(this.timerInterval)
		if (this.state.player.finished !== true) {
			this.state.socket.emit("arrive", {
				name: this.state.player.name,
				uuid: this.state.player.uuid,
				result: result
			})
		}
		this.state.player.finished = true
	}

	joinGame = () => {
		this.bindKeys()
		var name = this.nameInput.current.value.trim();
		if (!name == "") {
			this.setState({ joined: true }, () => {
				this.registerSocketListener()
				this.renderCanvas(name)
			})
		} else {
			alert("Please enter your name before join the game!")
		}
	}

	spectateGame = () => {
		this.bindSpectatorKeys()
		this.setState({ joined: true }, () => {
			this.registerSocketListener()
			this.renderCanvas()
		})
	}

	resetPos = () => {
		Matter.Body.setPosition(this.state.player, this.state.spawnPoint)
		Matter.Body.setVelocity(this.state.player, Matter.Vector.create(this.state.player.velocity.x, 0))
		Matter.Render.lookAt(this.myRender, this.state.player, {
			x: 400,
			y: 400,
		}, true)
		this.resetBtn.current.blur()
	}

	pushMessage = (name, join = true) => {
		var li = document.createElement("div");
		var nameSpan = document.createElement("span")
		nameSpan.appendChild(document.createTextNode(name))
		nameSpan.style.color = "blue"
		li.appendChild(nameSpan)
		li.appendChild(document.createTextNode(` ${join ? "joined" : "left"} the game`));
		li.style.textAlign = "left"
		this.messageList.current.appendChild(li)
	}

	gameLoop = () => {
		if (this.state.player && this.Render) {
			this.state.socket.emit("moving", { uuid: this.state.player.uuid, position: this.state.player.position, velocity: this.state.player.velocity, name: this.state.player.name, powered: this.state.player.powered, sleeping: this.state.player.sleeping })

			const playerPosition = this.state.player.position;
			// console.log(playerPosition)

			// Calculate the target point for lookAt with an offset
			const targetX = playerPosition.x;
			const targetY = playerPosition.y - 200; // Offset to position the player lower in the view

			// Use the lookAt function to adjust the camera
			// console.log(this.myRender);
			this.Render.lookAt(this.myRender, {
				min: { x: targetX - this.myRender.options.width / 2, y: 0 },
				max: { x: targetX + this.myRender.options.width / 2, y: 600 }
			});
		}
		requestAnimationFrame(this.gameLoop)
	}

	componentDidMount = () => {
		// this.nameInput.current.value = "Paul"
		// this.joinGame()
		this.timerInterval = setInterval(() => {
			if (this.state.startTime != undefined) {
				const d = new Date(Date.UTC(0, 0, 0, 0, 0, 0, Date.now() - this.state.startTime))
				var parts = [
					d.getUTCMinutes(),
					d.getUTCSeconds(),
					d.getMilliseconds(),
				]
				// Zero-pad
				// formatted = parts.map(s => String(s).padStart(2,'0')).join(':');
				this.timer.current.innerHTML = parts[0] + "m " + String(parts[1]).padStart(2, '0') + "s " + String(parts[2]).padStart(3, '0') + "ms"
			}
		})
		requestAnimationFrame(this.gameLoop)

	}

	render() {
		return (
			<div className=''>
				<Row className='justify-content-center' style={{ paddingTop: "20px", paddingBottom: "20px", display: this.state.joined ? 'none' : '' }}>
					<Col>
						<Row className='justify-content-end'>
							<input ref={this.nameInput} style={{ width: "250px" }} className="form-control" type="text" placeholder="Your Name" />
						</Row>
					</Col>

					<Col>
						<Row className='justify-content-start'>
							<button onClick={this.joinGame} style={{ width: '100px' }} type="button" className="btn btn-primary">Join Game</button>
							<button onClick={this.spectateGame} style={{ width: '150px', marginLeft: "25px" }} type="button" className="btn btn-primary">Spectator Game</button>
						</Row>

					</Col>
				</Row>
				<Row className=''>
					<div style={{ marginTop: "20px", marginBottom: "20px" }}>Welcome to UTS Interactive Game <span style={{ fontWeight: "bold", color: 'Blue' }}>{this.state.player.name}</span>!<span> Your time: <span ref={this.timer}>00m 00s 000ms</span></span></div>
				</Row>
				<div style={{ position: 'relative', display: this.state.joined ? '' : 'none' }}>

				</div>
				<Row style={{ display: this.state.joined ? '' : 'none' }}>
					<Col style={{ border: "1px ridge black" }}>
						Current Player: {this.state.players}
						<div ref={this.messageList}>
						</div>
					</Col>
					<Col style={{ border: "1px ridge black", position: "relative", padding: "0" }}>
						<div id="game-canvas" style={{ height: "600px", width: "900px" }} ref={this.gameCanvas}></div>
						{/* <button ref={this.resetBtn} onClick={this.resetPos} className="btn btn-primary shadow-none" style={{ fontSize: '25px', lineHeight: '0.8', paddingBottom: "10px", position: 'absolute', top: "20px", left: `20px`, borderl: 'none', opacity: "80%" }}>⟳</button> */}
					</Col>
					<Col style={{ border: "1px ridge black" }}>
						Ranking:
						<div ref={this.rankingList}>
						</div>
					</Col>
				</Row>
				<Row style={{ "textAlign": "center", "justifyContent": "start" }}>
					<Col style={{ "textAlign": "center", "justifyContent": "start" }}>
						<h6>Use the arrow keys/WASD to control your character.</h6>
						<h6>Getting the cookie will let you move faster for 3 seconds.</h6>
						<h6>Good Luck Have Fun!</h6>
					</Col>
				</Row>
			</div>
		);
	}
}
